import { Link } from 'react-router-dom';
import { useDrafts, type DraftKind } from '../api/drafts';

/** Shows a "resume your in-progress draft" banner above a list when the user has one. */
export function DraftBanner({ kind, to, label }: { kind: DraftKind; to: string; label: string }) {
  const drafts = useDrafts();
  const draft = drafts.data?.find((d) => d.kind === kind);
  if (!draft) return null;
  let when = '';
  try {
    when = ` · saved ${new Date(draft.updatedAt).toLocaleString()}`;
  } catch {
    /* ignore */
  }
  return (
    <div
      className="banner"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '0.75rem',
        background: 'var(--card)',
        border: '1px dashed var(--accent)',
      }}
    >
      <span>✎ You have a {label} draft in progress{when}.</span>
      <Link className="btn" to={to}>
        Resume draft
      </Link>
    </div>
  );
}
